__turbopack_context__.v({
  "actions": "CTA-module__CdZh3q__actions",
  "btnGhost": "CTA-module__CdZh3q__btnGhost",
  "btnPrimary": "CTA-module__CdZh3q__btnPrimary",
  "content": "CTA-module__CdZh3q__content",
  "cta": "CTA-module__CdZh3q__cta",
  "glow": "CTA-module__CdZh3q__glow",
  "panPattern": "CTA-module__CdZh3q__panPattern",
  "pattern": "CTA-module__CdZh3q__pattern",
  "subtitle": "CTA-module__CdZh3q__subtitle",
  "textWrapper": "CTA-module__CdZh3q__textWrapper",
  "title": "CTA-module__CdZh3q__title",
});
